import data_control from "../../../../../../engines/libs/data_control";
import ObjectUtil from "../../../../../../engines/libs/ObjectUtil";
import { MahjongKind } from "./MahjongKind";

 /**
    1-9 万
    11-19 条
    21-29 筒
    
    31-37 东南西北中发白
*/
/** 牌型数据区间 */
const CardTypeArea = [
    [1, 9],
    [11,19],
    [21,29],
    [31, 37],
]

export class MahjongDataManage {
    
    /**
     * 根据牌型生成牌数据
     * @param type 
     * @returns 
     */
    static generateCardType(type: number): MahjongKind.CardTypeData {
        let TYPE = MahjongKind.CardType;
        switch(type) {
            case TYPE.DUI_DUI_HU: {
                return this.generateDuiDuiHu();
            }
            case TYPE.QI_DUI: {
                return this.generateQiDui();
            }
            case TYPE.QING_YI_SE: {
                return this.generateQingYiSe();
            }
            case TYPE.HAO_QI_DUI: {
                return this.generateHaoQiDui();
            }
            case TYPE.QING_QI_DUI: {
                return this.generateQingQiDui();
            }
            case TYPE.PENG_QING: {
                return this.generatePengQing();
            }
            case TYPE.QING_HAO_QI_DUI: {
                return this.generateQingHaoQiDui();
            }
            case TYPE.SHI_SAN_YAO: {
                return this.generateShiSanYao();
            }
            case TYPE.JIU_LIAN_BAO_DENG: {
                return this.generateJiuLianBaoDeng();
            }
        }
    }

    /**
     * 获得牌数据
     * @param count 
     * @param sameNum 
     * @param ownCardData 
     * @returns 
     */
    static getSameCardData(
        count: number
        , sameNum: number
        , ownCardData: number[]
        , areaData: number[][] = null
    ) {
        let cardData: number[] = [];
        for (let i = 0; i < count; i++) {
            while(true) {
                let randomV = this.getRandomCard(areaData);
                if (!ownCardData.includes(randomV)) {
                    for (let j = 0; j < sameNum; j++) {
                        ownCardData.push(randomV);
                    }
                    cardData.push(randomV);
                    break;
                }
            }
        }
        return cardData;
    }

    /**
     * 获得随机牌
     * @returns 
     */
    static getRandomCard(
        areaData: number[][] = null
    ) {
        if (!areaData) {
            areaData = CardTypeArea;
        }
        let len = areaData.length;
        let random = data_control.randomNumInt(0, len-1);
        let cardArea = areaData[random];
        let value = data_control.randomNumInt(cardArea[0], cardArea[1]);
        return value;         
    }

    /**
     * 牌型数据是否相同花色
     * @param cardData 
     * @returns 
     */
    static isSameColor(cardData: number[]) {
        let curIdx: number = null;
        for (let o of cardData) {
            let idx = this.getCardTypeAreaIdx(o);
            if (idx != null) {
                if (curIdx == null) {
                    curIdx = idx;
                }
                if (curIdx != idx) {
                    return null;
                }
            }
        }
        return curIdx;
    }

    /**
     * 获得牌型区间索引
     * @param card 
     * @returns 
     */
    static getCardTypeAreaIdx(card: number) {
        for (let i = 0; i < CardTypeArea.length; i++) {
            let o = CardTypeArea[i];
            if (card >= o[0] && card <= o[1]) {
                return i;
            }
        }
        return null;
    }

    /**
     * 牌数统计
     * @param cardData 
     * @returns 
     */
    static getCardCountTotal(cardData: number[]) {
        cardData.sort((a1, a2)=> a1-a2);

        let curCard = -1;
        let sameNum = 0;
        let countTotal: number[][] = [[], [], [], []];

        for (let i = 0; i < cardData.length; i++) {
            let o = cardData[i];
            if (o != curCard) {
                curCard = o;
                sameNum = 1;
                countTotal[0].push(o);
            } else {
                sameNum++;
                if (sameNum == 2) {
                    countTotal[0].pop();
                    countTotal[1].push(o);
                } else if (sameNum == 3) {
                    countTotal[1].pop();
                    countTotal[2].push(o);
                } else if (sameNum == 4) {
                    countTotal[2].pop();
                    countTotal[3].push(o);
                }
            }
        }
        return countTotal;
    }

     /**
     * 牌数统计
     * @param cardData 
     * @returns 
     */
    static getCardDoubleCount(cardData: number[], sumCount: number) {
        let total = this.getCardCountTotal(cardData);
        return total[sumCount-1].length;
    }

    /**
     * 获得同色顺子, 不出现3张同样的牌
     * @param area 
     * @param excludeData 
     * @param count 
     * @returns 
     */
    static getSameColorOrderCard(
        area: number[]
        , excludeData: number[]
        , count: number
    ) {
        excludeData.sort((a1, a2)=> a1-a2);

        let orderStart: number[] = [];
        let cardData: number[] = [];
        let lastV = area[0];
        for (let i = 0; i < excludeData.length; i++) {
            let o = excludeData[i];
            let spo = o-lastV;
            if (spo >= 3) {
                let spl = spo-3;
                for (let j = 0; j <= spl; j++) {
                    orderStart.push(lastV + j);
                }
            }
            lastV = o+1;
            if (lastV > area[1]) {
                break;
            }
        }

        let sp = area[1] - lastV;
        if (sp >= 2) {
            let spl = sp-2;
            for (let j = 0; j <= spl; j++) {
                orderStart.push(lastV + j);
            }
        }

        let startUseV = {};
        for (let i = 0; i < count; i++) {
            let idx = data_control.randomNumInt(0, orderStart.length-1);
            let startIdx = orderStart[idx];
            let cardA = [startIdx, startIdx+1, startIdx+2];
            let bReset = false;
            for (let j = 0; j < cardA.length; j++) {
                let o = cardA[j];
                if (startUseV[o] && startUseV[o] >= 3) {
                    bReset = true;
                    break;
                }
            }
            if (bReset) {
                i--;
                continue;
            }

            for (let o of cardA) {
                if (!startUseV[o]) {
                    startUseV[o] = 1;
                } else {
                    startUseV[o]++;
                }
                cardData.push(o);
            }
        }
        return cardData;
    }

    /**
     * 生成对对胡 不能同一色
     * @returns 
     */
    static generateDuiDuiHu(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        if (data_control.isHitProbability(0.5)) {
            // 4个3张+单牌
            this.getSameCardData(4, 3, cardTypeData.card);
            let cIdx = this.isSameColor(cardTypeData.card);
            let areaData: number[][] = null;
            if (cIdx != null) {
                areaData = ObjectUtil.deepCopy(CardTypeArea);
                areaData.splice(cIdx, 1);
            }
            this.getSameCardData(1, 1, cardTypeData.card, areaData);
            let winCard = cardTypeData.card[cardTypeData.card.length-1];
            cardTypeData.winCard.push(winCard);
        } else {
            // 3个3张+2对牌
            this.getSameCardData(3, 3, cardTypeData.card);
            let cIdx = this.isSameColor(cardTypeData.card);
            let areaData: number[][] = null;
            if (cIdx != null) {
                areaData = ObjectUtil.deepCopy(CardTypeArea);
                areaData.splice(cIdx, 1);
            }
            let winCard = this.getSameCardData(2, 2, cardTypeData.card, areaData);
            cardTypeData.winCard = winCard;
        }
        return cardTypeData;
    }

    /**
     * 生成 七对 不能同一色
     * @returns 
     */
    static generateQiDui(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        //  六对牌+单张牌
        this.getSameCardData(6, 2, cardTypeData.card);
        let cIdx = this.isSameColor(cardTypeData.card);
        let areaData: number[][] = null;
        if (cIdx != null) {
            areaData = ObjectUtil.deepCopy(CardTypeArea);
            areaData.splice(cIdx, 1);
        }
        this.getSameCardData(1, 1, cardTypeData.card, areaData);
        let winCard = cardTypeData.card[cardTypeData.card.length-1];
        cardTypeData.winCard.push(winCard);
        return cardTypeData;
    }

    /**
     * 生成 清一色 不能全是对子
     * @returns 
     */
    static generateQingYiSe(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardArea: number[][] = [];
        let cardAreaTmp = cardArea[0] = CardTypeArea[randomIdx];

        while(true) {
            cardTypeData.card = [];
            // 0-2个3张
            let sameCount = data_control.randomNumInt(0, 2);
            let excludeData: number[] = [];
            if (sameCount > 0) {
                excludeData = this.getSameCardData(sameCount, 3, cardTypeData.card, cardArea);
            }

            // 随机顺子
            let cardData = this.getSameColorOrderCard(
                cardAreaTmp
                , excludeData
                , 4 - sameCount
            );
            cardTypeData.card = cardTypeData.card.concat(cardData);
            let doubleCount = this.getCardDoubleCount(cardTypeData.card, 2)
            if (doubleCount < 6) {
                break;
            } else {
                console.log('对子太多了');
            }
        }

        let notCard: number[] = [];
        for (let i = cardAreaTmp[0]; i <= cardAreaTmp[1]; i++) {
            if (!cardTypeData.card.includes(i)) {
                notCard.push(i);
            }
        }
        if (notCard.length > 0) {
            let idx = data_control.randomNumInt(0, notCard.length-1);
            cardTypeData.winCard.push(notCard[idx]);
            cardTypeData.card.push(notCard[idx]);
        } else {
            let total = this.getCardCountTotal(cardTypeData.card);
            for (let i = 0; i < total.length; i++) {
                let o = total[i];
                if (o.length > 0) {
                    let idx = data_control.randomNumInt(0, o.length-1);
                    cardTypeData.winCard.push(o[idx]);
                    cardTypeData.card.push(o[idx]);
                    break;
                }
            }
        }

        return cardTypeData;
    }
    
    /**
     * 生成 豪七对
     * @returns 
     */
    static generateHaoQiDui(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        if (data_control.isHitProbability(0.5)) {
            // 1个3张+5对
            this.getSameCardData(5, 2, cardTypeData.card);
            this.getSameCardData(1, 3, cardTypeData.card);
            let winCard = cardTypeData.card[cardTypeData.card.length-1];
            cardTypeData.winCard.push(winCard);
        } else {
            // 1个4张+4对 + 单牌
            this.getSameCardData(1, 4, cardTypeData.card);
            this.getSameCardData(4, 2, cardTypeData.card);
            let winCard = this.getSameCardData(1, 1, cardTypeData.card);
            cardTypeData.winCard = winCard;
        }
        return cardTypeData;
    }

    /**
     * 生成 清七对
     * @returns 
     */
    static generateQingQiDui(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();

        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardArea: number[][] = [];
        let cardAreaTmp = cardArea[0] = CardTypeArea[randomIdx];

         // 1个4张+4对 + 单牌
         this.getSameCardData(6, 2, cardTypeData.card, cardArea);
         let winCard = this.getSameCardData(1, 1, cardTypeData.card, cardArea);
         cardTypeData.winCard = winCard;
        return cardTypeData;
    }

    /**
     * 生成 碰清
     * @returns 
     */
    static generatePengQing(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardArea: number[][] = [];
        let cardAreaTmp = cardArea[0] = CardTypeArea[randomIdx];

        if (data_control.isHitProbability(0.5)) {
            // 4个3张+单牌
            this.getSameCardData(4, 3, cardTypeData.card, cardArea);
            this.getSameCardData(1, 1, cardTypeData.card, cardArea);
            let winCard = cardTypeData.card[cardTypeData.card.length-1];
            cardTypeData.winCard.push(winCard);
        } else {
            // 3个3张+2对牌
            this.getSameCardData(3, 3, cardTypeData.card, cardArea);
            let winCard = this.getSameCardData(2, 2, cardTypeData.card, cardArea);
            cardTypeData.winCard = winCard;
        }
        return cardTypeData;
    }

    /**
     * 生成 清豪七对
     * @returns 
     */
    static generateQingHaoQiDui(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardArea: number[][] = [];
        cardArea[0] = CardTypeArea[randomIdx];
        if (data_control.isHitProbability(0.5)) {
            // 1个3张+5对
            this.getSameCardData(5, 2, cardTypeData.card, cardArea);
            this.getSameCardData(1, 3, cardTypeData.card, cardArea);
            let winCard = cardTypeData.card[cardTypeData.card.length-1];
            cardTypeData.winCard.push(winCard);
        } else {
            // 1个4张+4对 + 单牌
            this.getSameCardData(1, 4, cardTypeData.card, cardArea);
            this.getSameCardData(4, 2, cardTypeData.card, cardArea);
            let winCard = this.getSameCardData(1, 1, cardTypeData.card, cardArea);
            cardTypeData.winCard = winCard;
        }
        return cardTypeData;
    }

    /**
     * 生成 十三幺
     * @returns 
     */
    static generateShiSanYao(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();

        let area = CardTypeArea[3];
        for (let i = area[0]; i <= area[1]; i++) {
            cardTypeData.card.push(i);
        }

        for (let i = 0; i < CardTypeArea.length-1; i++) {
            let o = CardTypeArea[i];
            cardTypeData.card.push(o[0], o[1]);
        }

        cardTypeData.winCard = [].concat(cardTypeData.card);
        return cardTypeData;
    }

    /**
     * 生成九连宝灯
     * @returns 
     */
    static generateJiuLianBaoDeng(): MahjongKind.CardTypeData {
        let cardTypeData = new MahjongKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CardTypeArea.length-2);
        let cardAreaTmp = CardTypeArea[randomIdx];
        for (let o of cardAreaTmp) {
            cardTypeData.card.push(o, o, o);
        }

        for (let i = cardAreaTmp[0]+1; i < cardAreaTmp[1]; i++) {
            cardTypeData.card.push(i);
        }
        
        for (let i = cardAreaTmp[0]; i <= cardAreaTmp[1]; i++) {
            cardTypeData.winCard.push(i);
        }
        return cardTypeData;
    }
    
}